import {
    GET_JOB_PACK,
    GET_NEW_JOB_PACK_UID,
    GET_USERS,
    UPLOAD_FILE,
    GET_REPORT_TYPES,
    SET_JOB_PACK,
    GET_SSWP_CONFIGS
} from "./types";
import firebase from "firebase/app";
import blankProfile from "./blankProfile";
import { push } from "connected-react-router";

export const getJobPack = (uid = false) => {
    return dispatch => {
        dispatch({ type: GET_JOB_PACK.REQUEST });
        if (uid) {
            try {
                firebase.auth().onAuthStateChanged(user => {
                    if (user) {
                        firebase
                            .database()
                            .ref(`/subjects/job_packs/${uid}`)
                            .on("value", snapshot => {
                                dispatch({
                                    type: GET_JOB_PACK.SUCCESS,
                                    payload: snapshot.val()
                                });
                            });
                    } else {
                        dispatch({ type: GET_JOB_PACK.FAIL });
                    }
                });
            } catch {
                dispatch({ type: GET_JOB_PACK.FAIL });
            }
        } else {
            return dispatch({ type: GET_JOB_PACK.FAIL });
        }
    };
};
export const getNewJobPackID = () => {
    return async dispatch => {
        dispatch({ type: GET_NEW_JOB_PACK_UID.REQUEST });
        let jobPacks = await getAllJobPacks();
        let newJobPackID;
        if (jobPacks) {
            let jobPackIDs = Object.keys(jobPacks).map(e => e);
            jobPackIDs = jobPackIDs.sort().reverse();
            newJobPackID = (Number(jobPackIDs[0]) + 1)
                .toString()
                .padStart(6, "0");
            dispatch({
                type: GET_NEW_JOB_PACK_UID.SUCCESS,
                payload: newJobPackID
            });
        } else if (jobPacks == null) {
            newJobPackID = "000001";
            dispatch({
                type: GET_NEW_JOB_PACK_UID.SUCCESS,
                payload: newJobPackID
            });
        } else return dispatch({ type: GET_NEW_JOB_PACK_UID.FAIL });
    };
};
export const getUsers = () => {
    return dispatch => {
        dispatch({ type: GET_USERS.REQUEST });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/users/`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_USERS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                } else {
                    dispatch({ type: GET_USERS.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_USERS.FAIL });
        }
    };
};
const getAllJobPacks = async () => {
    let user = await firebase.auth().onAuthStateChanged(user => {
        return user;
    });
    if (user) {
        let snapshot = await firebase
            .database()
            .ref(`/subjects/job_packs/`)
            .once("value");
        return snapshot.val();
    } else {
        return false;
    }
};
export const uploadFile = (uid, file, callback, newState) => {
    return async dispatch => {
        dispatch({ type: UPLOAD_FILE.REQUEST });

        let upload = firebase
            .storage()
            .ref(`files/job_packs/${uid}`)
            .child(file.name)
            .put(file);

        upload.on(
            "state_changed",
            snapshot => {
                let progress =
                    (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

                callback({
                    inProgress: true,
                    finished: false,
                    error: false,
                    progress: progress,
                    msg: "Upload is " + progress + "% done"
                });
            },
            error => {
                // Handle unsuccessful uploads
                callback({
                    inProgress: false,
                    finished: false,
                    error: true,
                    msg: "Something went wrong with this upload!"
                });
                dispatch({ type: UPLOAD_FILE.FAIL });
            },
            () => {
                upload.snapshot.ref.getDownloadURL().then(url => {
                    let newFile = { file: file.name, fileURL: url };
                    newState(newFile);

                    callback({
                        inProgress: false,
                        finished: true,
                        error: false,
                        msg: "Success"
                    });
                    dispatch({ type: UPLOAD_FILE.SUCCESS });
                });
            }
        );
    };
};
export const setJobPack = (jobPack = false, callback) => {
    return dispatch => {
        dispatch({ type: SET_JOB_PACK.REQUEST });
        if (jobPack) {
            //Check that all values have been filled to prevent undefined
            Object.keys(blankProfile).map(e => {
                if (jobPack[e] === "" && e !== "sswp_config_uid") {
                    jobPack[e] = "N/A";
                }
                return true;
            });

            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/subjects/job_packs/${jobPack.job_id}`)
                        .update({ profile: jobPack })
                        .then(() => {
                            dispatch({ type: SET_JOB_PACK.SUCCESS });
                            callback(true);
                        });
                } else {
                    dispatch({ type: SET_JOB_PACK.FAIL });
                    callback(false);
                }
            });
        } else {
            dispatch({ type: SET_JOB_PACK.FAIL });
            callback(false);
        }
    };
};
export const goToLink = url => {
    return dispatch => {
        dispatch(push(url));
    };
};
export const getReportTypes = () => {
    return dispatch => {
        dispatch({ type: GET_REPORT_TYPES.REQUEST });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/collections/report_titles/`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_REPORT_TYPES.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                } else {
                    dispatch({ type: GET_REPORT_TYPES.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_REPORT_TYPES.FAIL });
        }
    };
};
export const getSSWPConfigs = () => {
    return dispatch => {
        dispatch({ type: GET_SSWP_CONFIGS.REQUEST });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/collections/master_sswp_config`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_SSWP_CONFIGS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                } else {
                    dispatch({ type: GET_SSWP_CONFIGS.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_SSWP_CONFIGS.FAIL });
        }
    };
};
